module.exports = __webpack_public_path__ + "static/media/discord.d248fb5c.png";